import { PROJECT_CODE } from '../../constants/project';


/**
 * Classes for the toolbar components.
 *
 * @since 0.1.0
 */
export const CLASS_TOOLBAR       = `${ PROJECT_CODE }__toolbar`;
export const CLASS_TOOLBAR_BODY  = `${ CLASS_TOOLBAR }__body`;
export const CLASS_TOOLBAR_UI    = `${ CLASS_TOOLBAR }__ui`;
export const CLASS_TOOLBAR_GROUP = `${ CLASS_TOOLBAR }__group`;
